import type { SessionGenerationJobStatus } from '../api/sessionApi';

export function isDelayedAutomaticGenerationJob(
  job?: SessionGenerationJobStatus | null
): boolean {
  return job?.status === 'queued' && job.trigger_source !== 'manual' && Boolean(job.generate_after);
}
